import React from "react";
import { t } from "i18next";
import { useLocation, useNavigate } from "react-router";
const InvitationExpiry: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { message, text } = location.state ?? {};

  return (
    <div className="container my-5 text-center">
      {message && text ? (
        <div>
          <h4>{message}</h4>
          <p>{text}</p>
        </div>
      ) : (
        <h4 className="my-3">{t("404")}</h4>
      )}
      <button
        className="btn fg-btn fg-btn-small fg-btn-my-reg active"
        onClick={() => navigate("/")}
      >
        {t("goHome")}
      </button>
    </div>
  );
};

export default InvitationExpiry;
